import { JWEInvalid } from '../util/errors.js';
import { bitLength } from './iv.js';
const checkIvLength = (enc, iv) => {
    if (iv.length << 3 !== bitLength(enc)) {
        throw new JWEInvalid('Invalid Initialization Vector length');
    }
};
export default checkIvLength;



// WEBPACK FOOTER //
// ./~/jose/dist/browser/lib/check_iv_length.js